import Logo from '@/app/_components/logo';
import { Badge } from '@/app/_components/ui/badge';
import { SidebarHeader } from '@/app/_components/ui/sidebar';
import Link from '@/app/_adapters/next-link';
import Image from 'next/image';
import MAIAIcon from '@/app/_assets/maia-icon.svg';

interface AppSidebarHeaderSectionProps {
  isCollapsed: boolean;
}

export function AppSidebarHeaderSection({
  isCollapsed,
}: AppSidebarHeaderSectionProps) {
  return (
    <SidebarHeader>
      <Link
        href="/dashboard"
        className="flex items-center justify-center hover:bg-accent rounded-md p-1 duration-300"
      >
        {!isCollapsed ? (
          <Logo />
        ) : (
          <Badge className="text-md w-8 h-8">
            <Image src={MAIAIcon} alt="Logo" width={24} height={24} />
          </Badge>
        )}
      </Link>
    </SidebarHeader>
  );
}
